// Engine constants & solver defaults — PSD §4. Engine layer (framework-free).
export const ENGINE_VERSION = '1.0.0';
export const RECONCILE_TOLERANCE_USD = 0.01; // reconciliation hard contract: +/- $0.01
export const BREAKPOINT_MERGE_THRESHOLD_USD = 1; // merge breakpoints within $1
export const SOLVER_DEFAULT_TOLERANCE = 0.005; // 0.5%
export const SOLVER_DEFAULT_MAX_ITERATIONS = 100;
export const DLOM_CLAMP_MIN = 0; // ratio
export const DLOM_CLAMP_MAX = 0.6; // ratio — DLOM > 60% is implausible
export const FMV_MINIMUM_USD = 0.0001; // minimum representable cent-fraction for strike
export const SAFE_HARBOR_WINDOW_DAYS = 365;
export const ANCHOR_STALE_DAYS = 365; // F2.6 recency threshold
export const GRANT_DATE_STALE_DAYS = 365; // F9.3 grant > 12 months after valuation
export const REFRESH_DUE_DAYS = 365; // F9.4 annual refresh
// Numerical guards
export const LOG_EXP_CLAMP = 700; // clamp (r - q + sigma^2/2)*T arguments
export const FLOAT_NOISE_RELATIVE = 1e-9; // floating-point noise threshold relative to V
//# sourceMappingURL=constants.js.map